import Tabs from './tabs.js';
import { debounce  } from 'throttle-debounce';

class TabsExtended extends Tabs {
    config = {
        container: null,
        tabGroup: '.tab-group',
        tabWrap: '.tab-group-wrap',
        tabItem: '.tab-group__item',
        tabSticky: '.tab-group-wrap--sticky'
    }

    constructor(container) {
        super();

        // Bind elements
        this.config.container = container;

        // If block exists init function
        if($(this.config.container).length){
            this.init();
        }
    }

    init(){
        // Set class context outside of loop
        let _t = this;

        $(this.config.container).each(function(index, element){
            // Set tab class variables
            if($(element).find(_t.config.tabItem).length){
                let initTabs = new Tabs($(element), $(element).find(_t.config.tabItem));

                _t.toggleClass(element);
                _t.setOffset(element, _t);

                $(window).resize(debounce (500, function(){
                    _t.toggleClass(element);
                    _t.setOffset(element, _t);
                }));
            }
        });
    }

    setOffset(element, _t){
        if($(element).find(_t.config.tabSticky).length){
            // Set tab offset top
            let isMobile = $(window).innerWidth() < 1280;
            let headerNavHeight = $('.header').outerHeight() - ((isMobile) ? 5 : 1);
            let onPageNavHeight = $('.onpage-nav').outerHeight() - 1;
            let tabs = $(element).find(_t.config.tabSticky);
            let navHeight = isMobile ? (onPageNavHeight > 0 ? headerNavHeight + onPageNavHeight : 0) : headerNavHeight;

            tabs.css('--tab-group-offset', navHeight + 'px');
        }
    }

    toggleClass(element){
        // Add Class if Tabs Overflow
        if($(element).find(this.config.tabGroup)[0].offsetWidth < $(element).find(this.config.tabGroup)[0].scrollWidth && !$(element).find(this.config.tabGroup).hasClass('overflow')){
            $(element).find(this.config.tabWrap).addClass('overflow');
        } else if ($(element).find(this.config.tabGroup)[0].offsetWidth >= $(element).find(this.config.tabGroup)[0].scrollWidth && $(element).find(this.config.tabGroup).hasClass('overflow')) {
            $(element).find(this.config.tabWrap).removeClass('overflow');
        }
    }
}

export { TabsExtended as default }